import {assortments, getUserObject} from "utils/relewise";

function getPowerStepObject(options) {
  return {
    ProductAndVariantId: {
      ProductId: options.crossStoreProductId,
      VariantId: options.variantId,
    },
    Settings: {
      NumberOfRecommendations: 6,
      AllowFillIfNecessaryToReachNumberOfRecommendations: false,
      AllowReplacingOfRecentlyShownRecommendations: false,
      RecommendVariant: true,
      SelectedProductProperties: {
        DisplayName: true,
        Pricing: true,
      },
      SelectedVariantProperties: {
        DisplayName: true,
        Pricing: true,
        DataKeys: [
          "COM_ShopifyHandle",
          "DE_ShopifyHandle",
          "DK_ShopifyHandle",
          "SE_ShopifyHandle",
          "UK_ShopifyHandle",
          "NO_ShopifyHandle",
          "ImageUrls",
        ],
      },
    },
    Language: {
      Value: window.mosmosh.shop_local.iso,
    },
    User: getUserObject(),
    Filters: {
      Items: [
        {
          $type:
              "Relewise.Client.Requests.Filters.ProductDataFilter, Relewise.Client",
          Key: "Vendor",
          FilterOutIfKeyIsNotFound: true,
          MustMatchAllConditions: true,
          Conditions: {
            Items: [
              {
                $type:
                    "Relewise.Client.Requests.Conditions.EqualsCondition, Relewise.Client",
                Value: {
                  Value: options.vendor,
                },
                TypeName: "EqualsCondition",
              },
            ],
          },
          TypeName: "ProductDataFilter",
        },
        {
          $type:
              "Relewise.Client.Requests.Filters.ProductAssortmentFilter, Relewise.Client",
          Assortments: [assortments[window.mosmosh.shop_code]],
          TypeName: "ProductAssortmentFilter",
        },
        {
          $type:
              "Relewise.Client.Requests.Filters.VariantAssortmentFilter, Relewise.Client",
          Assortments: [assortments[window.mosmosh.shop_code]],
          TypeName: "VariantAssortmentFilter",
        },
      ],
    },
    DisplayedAtLocationType: "Product detail page - Power step",
  };
}

export default getPowerStepObject
